"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NumberFormatter_1 = __importDefault(require("@react/web/Common/NumberFormatter/NumberFormatter"));
class PriceOfferList {
    constructor(priceOffers) {
        this.priceOffers = priceOffers;
    }
    isEmpty() {
        return this.priceOffers.length === 0;
    }
    getCount() {
        return this.priceOffers.length;
    }
    hasMultiplePriceOffers() {
        return this.priceOffers.length > 1;
    }
    getFirstOffer() {
        var _a;
        return (_a = this.priceOffers[0]) !== null && _a !== void 0 ? _a : null;
    }
    sortByCheapest() {
        this.priceOffers.sort((a, b) => a.amount.withoutVat - b.amount.withoutVat);
        return this;
    }
    getCheapestPriceOffer() {
        return this.sortByCheapest().getFirstOffer();
    }
    getFlexiblePriceOffers() {
        return new PriceOfferList(this
            .priceOffers
            .filter((priceOffer) => priceOffer.isFlexible()));
    }
    getContractLengthString() {
        const contractLengths = this.priceOffers.flatMap((priceOffer) => { var _a; return ((_a = priceOffer.contractLengths) === null || _a === void 0 ? void 0 : _a.map((contractLength) => contractLength.value)) || []; });
        return NumberFormatter_1.default.formatContractLengths(Array.from(new Set(contractLengths)));
    }
    getMileageString() {
        const mileages = this.priceOffers.map((priceOffer) => priceOffer.mileageYearly);
        return NumberFormatter_1.default.formatMileageByMinMax(Array.from(new Set(mileages)));
    }
}
exports.default = PriceOfferList;
